import { Component, Input } from '@angular/core'

@Component({
  selector: 'jml-lib-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss']
})
export class LogComponent {
  @Input() value: string = ''
  @Input() height: number = 3
}
